import React from 'react'
import { Headline } from 'msp-components'

type ListHeaderProps = {
  className?: string
  children?: string
  count?: number
  showCount?: boolean
}

const ListHeader = ({
  children = '',
  count = 0,
  showCount = true,
  ...props
}: ListHeaderProps) => {
  return (
    <Headline className='text-black' tag='h2' tagStyle='h3' {...props}>
      {children}
      {showCount && ` | ${count}`}
    </Headline>
  )
}

export default ListHeader
